export const SCHOLARSHIPS = [
  {
    "id": "kgsp",
    "title": "Korean Government Scholarship (GKS)",
    "country": "South Korea",
    "country_code": "KR",
    "flag": "🇰🇷",
    "levels": ["UG", "Masters", "PhD"],
    "featured": true,
    "deadlines": [
      {"levels": ["UG"], "date": "Sep–Oct"},
      {"levels": ["Masters", "PhD"], "date": "Feb–Mar (Embassy) / Mar–Apr (University)"}
    ],
    "summary": "Full tuition, monthly stipend, airfare, Korean language training and settlement allowance."
  },
  {
    "id": "mext",
    "title": "MEXT Scholarship",
    "country": "Japan",
    "country_code": "JP",
    "flag": "🇯🇵",
    "levels": ["UG", "Masters", "PhD"],
    "featured": true,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "May–June"}
    ],
    "summary": "Japanese government scholarship covering tuition, living expenses, and travel."
  },
  {
    "id": "daad",
    "title": "DAAD Scholarship",
    "country": "Germany",
    "country_code": "DE",
    "flag": "🇩🇪",
    "levels": ["Masters", "PhD"],
    "featured": true,
    "deadlines": [
      {"levels": ["Masters", "PhD"], "date": "Varies by programme"}
    ],
    "summary": "Monthly stipend, health insurance, and travel allowance for graduate study in Germany."
  },
  {
    "id": "csc",
    "title": "Chinese Government Scholarship (CSC)",
    "country": "China",
    "country_code": "CN",
    "flag": "🇨🇳",
    "levels": ["UG", "Masters", "PhD"],
    "featured": true,
    "deadlines": [
      {"levels": ["UG"], "date": "Jan–Feb"},
      {"levels": ["Masters", "PhD"], "date": "Feb–Apr"}
    ],
    "summary": "Full or partial scholarship covering tuition, accommodation, stipend and medical insurance."
  },
  {
    "id": "opendoors",
    "title": "Open Doors Scholarship",
    "country": "Russia",
    "country_code": "RU",
    "flag": "🇷🇺",
    "levels": ["UG", "Masters", "PhD"],
    "featured": true,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "December"}
    ],
    "summary": "Tuition-free study at top Russian universities for international students."
  },
  {
    "id": "bangkok",
    "title": "Bangkok Government Scholarship",
    "country": "Thailand",
    "country_code": "TH",
    "flag": "🇹🇭",
    "levels": ["Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters", "PhD"], "date": "Annual cycle"}
    ],
    "summary": "Scholarships at top Thai universities for graduate study."
  },
  {
    "id": "chevening",
    "title": "Chevening Scholarship",
    "country": "United Kingdom",
    "country_code": "GB",
    "flag": "🇬🇧",
    "levels": ["Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters"], "date": "Aug–Nov"}
    ],
    "summary": "Fully-funded UK Government Master's scholarship for future leaders."
  },
  {
    "id": "commonwealth",
    "title": "Commonwealth Shared Scholarships",
    "country": "United Kingdom",
    "country_code": "GB",
    "flag": "🇬🇧",
    "levels": ["Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters"], "date": "Oct–Dec"}
    ],
    "summary": "For students from low- and middle-income Commonwealth countries."
  },
  {
    "id": "danish",
    "title": "Danish Government Scholarship",
    "country": "Denmark",
    "country_code": "DK",
    "flag": "🇩🇰",
    "levels": ["Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters"], "date": "Jan–Mar"}
    ],
    "summary": "Tuition waivers and living grants for Master's students in Denmark."
  },
  {
    "id": "eiffel",
    "title": "Eiffel Excellence Scholarship",
    "country": "France",
    "country_code": "FR",
    "flag": "🇫🇷",
    "levels": ["Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters", "PhD"], "date": "January"}
    ],
    "summary": "French Ministry scholarship covering monthly allowance, travel and insurance."
  },
  {
    "id": "erasmus",
    "title": "Erasmus Mundus Joint Masters",
    "country": "Europe",
    "country_code": "EU",
    "flag": "🇪🇺",
    "levels": ["Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters"], "date": "Oct–Jan"}
    ],
    "summary": "Fully-funded joint Master's across multiple European universities."
  },
  {
    "id": "ireland",
    "title": "Ireland Government Scholarship",
    "country": "Ireland",
    "country_code": "IE",
    "flag": "🇮🇪",
    "levels": ["Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters", "PhD"], "date": "March"}
    ],
    "summary": "Government of Ireland International Education Scholarship."
  },
  {
    "id": "hungary",
    "title": "Hungary Government Scholarship",
    "country": "Hungary",
    "country_code": "HU",
    "flag": "🇭🇺",
    "levels": ["UG", "Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "January"}
    ],
    "summary": "Stipendium Hungaricum – full tuition, monthly stipend and accommodation."
  },
  {
    "id": "orange",
    "title": "Orange Knowledge Programme",
    "country": "Netherlands",
    "country_code": "NL",
    "flag": "🇳🇱",
    "levels": ["Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters"], "date": "Varies"}
    ],
    "summary": "Dutch government short courses & Master's programmes for selected countries."
  },
  {
    "id": "qecs",
    "title": "Queen Elizabeth Commonwealth Scholarships",
    "country": "Commonwealth",
    "country_code": "GB",
    "flag": "🇬🇧",
    "levels": ["Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters"], "date": "Nov–Jan"}
    ],
    "summary": "Cross-Commonwealth Master's awards funded by the Association of Commonwealth Universities."
  },
  {
    "id": "siga",
    "title": "Singapore International Graduate Award",
    "country": "Singapore",
    "country_code": "SG",
    "flag": "🇸🇬",
    "levels": ["PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["PhD"], "date": "Jun / Dec"}
    ],
    "summary": "PhD scholarship at A*STAR research institutes and Singaporean universities."
  },
  {
    "id": "swedish",
    "title": "Swedish Institute Scholarships",
    "country": "Sweden",
    "country_code": "SE",
    "flag": "🇸🇪",
    "levels": ["Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters"], "date": "February"}
    ],
    "summary": "Scholarships for Global Professionals – tuition, living costs, insurance and travel."
  },
  {
    "id": "swiss",
    "title": "Swiss Government Excellence Scholarship",
    "country": "Switzerland",
    "country_code": "CH",
    "flag": "🇨🇭",
    "levels": ["PhD", "PostDoc"],
    "featured": false,
    "deadlines": [
      {"levels": ["PhD", "PostDoc"], "date": "Sep–Dec"}
    ],
    "summary": "Research scholarships at Swiss universities and federal institutes of technology."
  },
  {
    "id": "turkey",
    "title": "Türkiye Bursları Scholarship",
    "country": "Türkiye",
    "country_code": "TR",
    "flag": "🇹🇷",
    "levels": ["UG", "Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "Jan–Feb"}
    ],
    "summary": "Full scholarship including tuition, monthly stipend, accommodation and Turkish language course."
  },
  {
    "id": "anso",
    "title": "ANSO Scholarship",
    "country": "China",
    "country_code": "CN",
    "flag": "🇨🇳",
    "levels": ["Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters", "PhD"], "date": "March"}
    ],
    "summary": "Alliance of International Science Organizations scholarship at UCAS, China."
  },
  {
    "id": "hkpfs",
    "title": "Hong Kong PhD Fellowship Scheme",
    "country": "Hong Kong",
    "country_code": "HK",
    "flag": "🇭🇰",
    "levels": ["PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["PhD"], "date": "Sep–Dec"}
    ],
    "summary": "Generous monthly stipend and conference travel allowance for outstanding PhD candidates."
  },
  {
    "id": "mis",
    "title": "Malaysian International Scholarship",
    "country": "Malaysia",
    "country_code": "MY",
    "flag": "🇲🇾",
    "levels": ["Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["Masters", "PhD"], "date": "Annual cycle"}
    ],
    "summary": "Scholarships for international students to pursue postgraduate study at Malaysian universities."
  },
  {
    "id": "knb",
    "title": "KNB Scholarship",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "Apr–May"}
    ],
    "summary": "Indonesian government scholarship with tuition and living allowance."
  },
  {
    "id": "waikato",
    "title": "University of Waikato Scholarship",
    "country": "New Zealand",
    "country_code": "NZ",
    "flag": "🇳🇿",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "Varies"}
    ],
    "summary": "Merit-based scholarships for international students at University of Waikato."
  },
  {
    "id": "uin_datokarama",
    "title": "Universitas Datokarama",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "10 May 2026"}
    ],
    "summary": "Scholarship at Universitas Datokarama Palu, Indonesia.",
    "official_site": "https://uindatokarama.ac.id"
  },
  {
    "id": "upi",
    "title": "Universitas Pendidikan Indonesia (UPI)",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "19 May 2026"}
    ],
    "summary": "Scholarship programmes at UPI, Bandung.",
    "official_site": "https://www.upi.edu"
  },
  {
    "id": "upnvj",
    "title": "UPN Veteran Jakarta",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "21 May 2026"}
    ],
    "summary": "UPN Veteran Jakarta scholarship awards.",
    "official_site": "https://www.upnvj.ac.id"
  },
  {
    "id": "uksw",
    "title": "Satya Wacana Christian University",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "31 May 2026"}
    ],
    "summary": "International scholarship at Satya Wacana Christian University.",
    "official_site": "https://www.uksw.edu"
  },
  {
    "id": "um_malang",
    "title": "Universitas Negeri Malang (UM)",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "31 May 2026"}
    ],
    "summary": "Scholarship at Universitas Negeri Malang.",
    "official_site": "https://www.um.ac.id"
  },
  {
    "id": "umsu",
    "title": "Universitas Sumatera Utara (USU/UMSU)",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "31 May 2026"}
    ],
    "summary": "USU / UMSU international scholarship.",
    "official_site": "https://www.usu.ac.id"
  },
  {
    "id": "unp",
    "title": "Universitas Negeri Padang (UNP)",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "31 May 2026"}
    ],
    "summary": "UNP international scholarship.",
    "official_site": "https://www.unp.ac.id"
  },
  {
    "id": "telkom",
    "title": "Telkom University",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "31 May 2026"}
    ],
    "summary": "Telkom University scholarship for international students.",
    "official_site": "https://telkomuniversity.ac.id"
  },
  {
    "id": "uin_saizu",
    "title": "UIN Saizu",
    "country": "Indonesia",
    "country_code": "ID",
    "flag": "🇮🇩",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "15 June 2026"}
    ],
    "summary": "UIN Prof. K.H. Saifuddin Zuhri Purwokerto scholarship.",
    "official_site": "https://www.uinsaizu.ac.id"
  },
  {
    "id": "bolashak",
    "title": "Kazakhstan Government Scholarship (Bolashak)",
    "country": "Kazakhstan",
    "country_code": "KZ",
    "flag": "🇰🇿",
    "levels": ["UG", "Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "31 May 2026"}
    ],
    "summary": "Government of Kazakhstan international scholarship programme.",
    "official_site": "https://bolashak.gov.kz"
  },
  {
    "id": "saudi_govt",
    "title": "Saudi Government Scholarships",
    "country": "Saudi Arabia",
    "country_code": "SA",
    "flag": "🇸🇦",
    "levels": ["UG", "Masters", "PhD"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters", "PhD"], "date": "14 June 2026"}
    ],
    "summary": "Ministry of Education, Saudi Arabia – international scholarship programme.",
    "official_site": "https://studyinsaudi.moe.gov.sa"
  },
  {
    "id": "al_qasimia",
    "title": "Al Qasimia University",
    "country": "United Arab Emirates",
    "country_code": "AE",
    "flag": "🇦🇪",
    "levels": ["UG", "Masters"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG", "Masters"], "date": "30 June 2026"}
    ],
    "summary": "Al Qasimia University, Sharjah – international scholarship awards.",
    "official_site": "https://alqasimia.ac.ae"
  },
  {
    "id": "al_bukhary",
    "title": "Al Bukhary International University",
    "country": "Malaysia",
    "country_code": "MY",
    "flag": "🇲🇾",
    "levels": ["UG"],
    "featured": false,
    "deadlines": [
      {"levels": ["UG"], "date": "31 July 2026"}
    ],
    "summary": "Al Bukhary International University Bachelor's scholarship.",
    "official_site": "https://www.aiu.edu.my"
  }
];
